const styles = (theme) => ({
  dataGrid: {
    border: `1px solid ${theme.AppBGColor}`,
    "& .gridCell-greenBackground": {
      background: `rgba(54, 181, 178, 0.1)`,
      margin: "5px",
    },
    "& .dispatch-grid-disable-button": {
      color: theme.iconColor,
      border: `0.5px solid ${theme.iconColor}`,
    },

    "& .dispatch-grid-active-button": {
      color: theme.palette.primary.main,
      border: `0.5px solid ${theme.palette.primary.main}`,
    },
  },
  assetManagementModule: {
    height: "94%",
    width: "100%",
  },
  subModule: {
    height: "100%",
    display: "flex",
  },
  withMapModule: {
    height: "100%",
    display: "flex",
    "& .subDiv": {
      width: "50%",
      boxSizing: "border-box",
    },
  },
  headerStyle: {
    paddingRight: "10px",
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
  },
  headerIconStyles: {
    padding: 10,
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor,
    cursor: "pointer",
  },
  iconLayout: {
    color: theme.iconColor,
    zIndex: 1,
    "&>span": {
      padding: "10px 10px",
      color: theme.iconColor,
    },
  },
  tabsIndicator: {
    backgroundColor: theme.HeaderSelectedText,
  },
  tabRoot: {
    fontWeight: "600",
    fontSize: theme.textFontSize,
    lineHeight: "24px",
    color: theme.iconColor,
    minWidth: 60,
    "&:hover": {
      color: theme.HeaderSelectedText,
    },
    "&$tabSelected": {
      color: theme.HeaderSelectedText,
    },
    "&:focus": {
      color: theme.HeaderSelectedText,
    },
  },
  tabSelected: {
    color: theme.HeaderSelectedText,
  },
  toggleAnimationButton: {
    float: "left",
    cursor: "pointer",
    padding: "3px 0px",
    display: "flex",
    alignItems: "center",
  },
  toggleAnimationButtonDispatchMap: {
    float: "left",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      padding: "3px 8px",
    },
  },
  toggleAnimationButtonMenu: {
    justifyContent: "space-between",
  },
  toggleText: {
    display: "inline-block",
    fontSize: "12px",
    color: theme.iconColor,
  },
  iconContainer: {
    zIndex: 100,
    display: "flex",
    alignItems: "center",
  },
  disableIcon: {
    cursor: "not-allowed",
    opacity: 0.7,
  },
  enableIcon: {
    cursor: "pointer",
  },
  paperAnchor: {
    position: "absolute",
    width: 300,
    zIndex: 110,
    backgroundColor: theme.ModalBGColor,
  },
});
export default styles;
